import { CourseOutcome } from "app/core/models/course-outcome";
// import { OutcomeMapValue } from "app/models/outcome-map-value";

export class CourseOutcomeValue extends CourseOutcome {
  private _outcomeMaps: Array<number> = [];
  private _isCompleted: boolean;
  private _hasNoMapping: boolean;

  /**
   * Getter outcomeMaps
   * @return {Array<OutcomeMapValue> }
   */
  public get outcomeMaps(): Array<number> {
    return this._outcomeMaps;
  }

  /**
   * Setter outcomeMaps
   * @param {Array<OutcomeMapValue> } value
   */
  public set outcomeMaps(value: Array<number>) {
    this._outcomeMaps = value;
  }

  /**
   * Getter isCompleted
   * @return {boolean}
   */
  public get isCompleted(): boolean {
    return this._isCompleted;
  }

  /**
   * Setter isCompleted
   * @param {boolean} value
   */
  public set isCompleted(value: boolean) {
    this._isCompleted = value;
  }

  /**
   * Getter hasNoMapping
   * @return {boolean}
   */
  public get hasNoMapping(): boolean {
    return this._hasNoMapping;
  }

  /**
   * Setter hasNoMapping
   * @param {boolean} value
   */
  public set hasNoMapping(value: boolean) {
    this._hasNoMapping = value;
  }
}
